<vpfa-return-report-modal
  [processing]="processing$ | async"
  [open]="open$ | async"
  [report]="report$ | async"
  (closeAction)="close()"
  (save)="save($event)"
></vpfa-return-report-modal>
